import { queryOptions } from '@tanstack/react-query';
import { z } from 'zod';
import { api } from '@/shared/api/client';

export interface SearchAttribute {
  id: string;
  name: string;
  translationKey: string;
  productLines: string[];
  allowedValues: { value: string; translationKey: string }[];
}

const searchAttributeSchema = z.object({
  id: z.string(),
  name: z.string(),
  translationKey: z.string(),
  productLines: z.array(z.string()),
  allowedValues: z.array(z.object({ value: z.string(), translationKey: z.string() })),
});

export const searchAttributesQueryKey = ['search-attributes'] as const;

export const searchAttributesQueryOptions = () =>
  queryOptions({
    queryKey: searchAttributesQueryKey,
    queryFn: () => api.get<SearchAttribute[]>('search-attribute', { schema: z.array(searchAttributeSchema) }),
  });

export type SearchAttributeInput = {
  name: string;
  productLines: string[];
  allowedValues: string[];
};

export const createSearchAttribute = (data: SearchAttributeInput) =>
  api.post<SearchAttribute>('search-attribute', data, {
    schema: searchAttributeSchema,
  });
export const updateSearchAttribute = (id: string, data: SearchAttributeInput) =>
  api.put<SearchAttribute>(`search-attribute/${encodeURIComponent(id)}`, data, {
    schema: searchAttributeSchema,
  });
export const deleteSearchAttribute = (id: string) =>
  api.delete<unknown>(`search-attribute/${encodeURIComponent(id)}`);